module.exports = __webpack_public_path__ + "static/media/plus-solid.f520ccd4.svg";